// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import AddressTypeEnumViewModel from '../../../../viewModel/resource/AddressTypeEnumViewModel';
import AddressResourceViewModel from '../../../../viewModel/resource/AddressResourceViewModel';
import AddressResourceDTO from '../../dto/resource/AddressResourceDTO';

export default abstract class AddressResourceModel extends BaseModel<AddressResourceDTO> {
  /**
  * @type {int32}
  */
  get addressType() { return this.dto.addressType; }
  set addressType(value) { this.dto.addressType = value; }
  /**
  */
  get city() { return this.dto.city; }
  set city(value) { this.dto.city = value; }
  /**
  */
  get company() { return this.dto.company; }
  set company(value) { this.dto.company = value; }
  /**
  */
  get email() { return this.dto.email; }
  set email(value) { this.dto.email = value; }
  /**
  */
  get fax() { return this.dto.fax; }
  set fax(value) { this.dto.fax = value; }
  /**
  */
  get firstname() { return this.dto.firstname; }
  set firstname(value) { this.dto.firstname = value; }
  /**
  */
  get lastname() { return this.dto.lastname; }
  set lastname(value) { this.dto.lastname = value; }
  /**
  */
  get sex() { return this.dto.sex; }
  set sex(value) { this.dto.sex = value; }
  /**
  */
  get poBox() { return this.dto.poBox; }
  set poBox(value) { this.dto.poBox = value; }
  /**
  */
  get postCode() { return this.dto.postCode; }
  set postCode(value) { this.dto.postCode = value; }
  /**
  */
  get street() { return this.dto.street; }
  set street(value) { this.dto.street = value; }
  /**
  */
  get telephone() { return this.dto.telephone; }
  set telephone(value) { this.dto.telephone = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.addresstype);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.addressType = value;
    this.dto.city = qs.city;
    this.dto.company = qs.company;
    this.dto.email = qs.email;
    this.dto.fax = qs.fax;
    this.dto.firstname = qs.firstname;
    this.dto.lastname = qs.lastname;
    this.dto.sex = qs.sex;
    this.dto.poBox = qs.pobox;
    this.dto.postCode = qs.postcode;
    this.dto.street = qs.street;
    this.dto.telephone = qs.telephone;
  }
}
